export class PlannedMortalitySubmissions {
    Submissions;
    constructor(submissions) {
        this.Submissions = submissions && Array.isArray(submissions) ? [...submissions] : [];
    }
}